import { Scene } from './scene/Scene'
import { PoseList } from './ui/PoseList'
import { ControlPanel } from './ui/ControlPanel'
import { DetailPanel } from './ui/DetailPanel'
import { Timeline } from './ui/Timeline'
import { AboutModal } from './ui/AboutModal'
import { LoadingOverlay } from './ui/LoadingOverlay'
import { POSE_COUNT } from './poses/library'
import { useAppStore } from './store'
import './App.css'
import { BRAND, isBranded } from './brand'

export default function App() {
  const setShowAbout = useAppStore((s) => s.setShowAbout)

  return (
    <div className="app-shell">
      <header className="app-header" style={BRAND.color ? { borderBottom: `4px solid ${BRAND.color}` } : undefined}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {BRAND.logo && <img src={BRAND.logo} alt={BRAND.name} style={{ height: 40 }} />}
          <div>
          <h1 style={BRAND.color ? { color: BRAND.color } : undefined}>{isBranded ? BRAND.name : 'Yoga Anatomy Studio'}</h1>
          <p className="tagline">Interactive anatomy for yoga instructors · {POSE_COUNT} poses{isBranded ? ' · powered by Yoga Anatomy Studio' : ''}</p>
          </div>
        </div>
        <button type="button" className="linkish" onClick={() => setShowAbout(true)}>
          About / Limitations
        </button>
      </header>

      <div className="app-main">
        <PoseList />
        <div className="viewport-column">
          <Scene />
          <Timeline />
        </div>
        <div className="right-column">
          <ControlPanel />
          <DetailPanel />
        </div>
      </div>

      <LoadingOverlay />
      <AboutModal />
    </div>
  )
}
